module.exports = __webpack_public_path__ + "static/media/yash_datta.89236235.jpeg";